module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "cont",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH",
    attrs: {
      "id": "cont"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "2",
      "id": "pg_2",
      "role": "doc-pagebreak"
    }
  }, [_c('samp', {
    staticClass: "SANS_Northwell_Clean_Regular_17"
  }, [_vm._v("Contents")])])])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Bold_B_17"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Using this book")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Tools and materials")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part2"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Bold_B_17"
  }, [_vm._v("EXPLORING WATERCOLOR")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Approaching the blank page")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Mixing your paints")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Practice exercises")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Understanding lighting and shading")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Understanding color")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Bold_B_17"
  }, [_vm._v("ILLUSTRATING FASHION")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Working in the fashion industry")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Bold_B_17"
  }, [_vm._v("CREATING A CHARACTER")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("General features")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Women’s faces")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Men’s faces")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Hair")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Painting beautiful hair")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Bold_B_17"
  }, [_vm._v("POSES")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("The body")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Examples")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Bold_B_17"
  }, [_vm._v("RENDERING FABRICS AND PRINTS")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Exploring fabrics and textures")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Prints and patterns")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part7",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Bold_B_17"
  }, [_vm._v("TUTORIALS")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Canvas tote bag")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Wedge platform shoe")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Gown on mannequin")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Womenswear head to toe")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Menswear head to toe")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Girl with bag")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Eye makeup")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Girl with hat")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Woman in print dress")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Boy with hat")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Perfumes")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Focus on beauty")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Girl with sunglasses")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Man in print shirt")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Vintage jewelry")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Menswear composition")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Catwalk moment")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Close-up beauty look")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Womenswear composition")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Editorial with background")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part8",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Bold_B_17"
  }, [_vm._v("READY FOR BUSINESS")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Digitizing your work")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Mixed media")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Working live")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Developing personal style")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT-TOP"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("About the author and acknowledgements")])])])]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "3",
      "id": "pg_3",
      "role": "doc-pagebreak"
    }
  }, [_c('figure', {
    staticClass: "IMG-BRK"
  }, [_c('img', {
    staticClass: "img100",
    attrs: {
      "alt": "",
      "src": "images/pg3.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 60
// module chunks = 0